import { CalendarGroupDisplayOrderData } from '../utils/DisplayOrderData';
import { convertEwsIdToRestId } from 'owa-identifiers';
import { createRestApiRequestHeaders } from 'owa-headers';
import { makePostRequest } from 'owa-ows-gateway';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import logErrorResponse from '../utils/logErrorResponse';
import {
    SCENARIONAME_HEADERNAME,
    SCENARIONAME_HEADERVALUE,
    FETCH_CALENDARGROUPS_ENDPOINT,
} from '../utils/DisplayOrderConstants';
import { UpdateDisplayOrderResponse } from '../utils/UpdateDisplayOrderResponse';

/**
 * Update calendar group display order using REST API
 */
export default async function updateCalendarGroupDisplayOrderRESTService(
    userIdentity: string,
    calendarGroupId: string,
    calendarGroupDisplayOrderData: CalendarGroupDisplayOrderData
): Promise<UpdateDisplayOrderResponse> {
    const calendarGroupRestId = convertEwsIdToRestId(calendarGroupId) as string;
    const query = FETCH_CALENDARGROUPS_ENDPOINT + `/${calendarGroupRestId}/reorder`;
    const headers = await createRestApiRequestHeaders(userIdentity);
    headers[SCENARIONAME_HEADERNAME] = SCENARIONAME_HEADERVALUE;

    const response = await makePostRequest(
        query /* requestUrl */,
        calendarGroupDisplayOrderData /* requestObject */,
        undefined /* correlationId */,
        true /* returnFullResponse */,
        headers /* customHeaders */,
        true /* throwServiceError */,
        true /* sendPayloadAsBody */,
        false /* includecredentials */
    );

    if (isSuccessStatusCode(response.status)) {
        return response.json();
    } else {
        const errorResponse = await response.json();
        logErrorResponse('UpdateCalendarGroupDisplayOrderError', {
            ...errorResponse?.error,
            status: response.status,
        });
        return null;
    }
}
